module.exports = __webpack_public_path__ + "img/44.baaab152.jpg";